import React from "react";
import { Users, Book } from "lucide-react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Button } from "../ui/button";
import SidebarSection from "./SidebarSection";
import { COURSES } from "@/data/courseSections";
import { useSidebarState } from "@/hooks/useSidebarState";
import { getCoursePath } from "@/lib/utils";

const SidebarNav = () => {
  const { expandedItems, toggleItem, setItemExpanded } = useSidebarState();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { courseSlug, sectionId, lessonId } = useParams();

  const course = COURSES.find((course) => course.slug === courseSlug);

  const isActiveSection = (path: string) => pathname.includes(path);

  return (
    <div className="flex flex-col">
      {/* Classroom Management Section */}
      <div className="mb-3">
        <Button
          variant="ghost"
          className={`flex justify-start gap-2 px-3 py-2 text-sm font-medium w-full ${isActiveSection("/classroom") ? "bg-blue-50 text-teachstack-purple" : "hover:bg-gray-100"}`}
          onClick={() => navigate(`/course/${courseSlug}/classroom`)}
        >
          <Users className="h-4 w-4" />
          <span>Classroom Management</span>
        </Button>
      </div>

      {/* Course Content Section */}
      <div className="border-t border-gray-200 pt-3">
        <div className="flex items-center gap-2 px-3 py-2 mb-2 text-sm font-medium">
          <Book className="h-4 w-4" />
          <span>Course Content</span>
        </div>
        <div className="flex flex-col">
          {course.course.map((section, index) => {
            return (
              <SidebarSection
                key={section.slug}
                number={index + 1}
                section={section}
                expanded={expandedItems[`section${index}`]}
                onToggle={() => toggleItem(`section${index}`)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SidebarNav;
